// TODO: delete with FEATURE_FLAG_STUDIO_V2
import { EMPTY } from '../constants';

import actions from '../actions';

function* listingSelected(reduction, id) {
  const state = reduction.get('studioEditor');
  const listing = state.getIn(['listings', 'byId', id]);

  function updatePhotos(photos) {
    return photos
      .set('changed', EMPTY.SET)
      .set('history', EMPTY.SET)
      .set('selected', photos.get('selected', photos.get('ids').last()));
  }

  return reduction.set('studioEditor',
    state
      .set('listing', listing.delete('photos'))
      .set('photos', listing.get('photos').update(updatePhotos))
  );
}

function* resetState(state) {
  return state.set('studioEditor', EMPTY.MAP);
}

function* setValue(reduction, { path, value }) {
  if (!path) return reduction;

  const fullPath = Array.isArray(path)
    ? ['studioEditor', ...path]
    : ['studioEditor', path];

  return value === undefined
    ? reduction.deleteIn(fullPath)
    : reduction.setIn(fullPath, value);
}

const studioEditor = {
  [actions.studioEditor.listingSelected]: listingSelected,
  [actions.studioEditor.resetState]: resetState,
  [actions.studioEditor.setValue]: setValue,
};

export default studioEditor;
